<administrasjon-navigasjon aktiv="meldinger">
    <form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
        <mat-form-field>
            <mat-label>{{ 'Meldingstype' | translate }}</mat-label>
            <mat-select [formControl]="skjema.controls.meldingstype">
                @for (meldingstype of meldingstyper; track meldingstype.verdi) {
                    <mat-option [value]="meldingstype.verdi">{{ meldingstype.navn }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (!erDetteErNyttMelding()) {
            <mat-form-field>
                <mat-label>{{ 'Varseltype' | translate }}</mat-label>
                <mat-select [formControl]="skjema.controls.varseltype">
                    @for (varseltype of varseltyper; track varseltype.verdi) {
                        <mat-option [value]="varseltype.verdi">{{ varseltype.navn }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'Varighet' | translate }}</mat-label>
                <mat-select [formControl]="skjema.controls.varighetIMinutter">
                    @for (varighet of varigheter; track varighet.verdi) {
                        <mat-option [value]="varighet.verdi">{{ varighet.navn }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (erDetteErNyttMelding()) {
            <mat-form-field class="full-bredde">
                <mat-label>{{ 'URL' | translate }}</mat-label>
                <input matInput type="url" [formControl]="skjema.controls.melding">
            </mat-form-field>
        } @else {
            <mat-form-field class="full-bredde">
                <mat-label>{{ 'Melding' | translate }}</mat-label>
                <riktekst-redigering [skjemakontroll]="skjema.controls.melding"/>
            </mat-form-field>
        }

        <button mat-raised-button color="primary" type="submit" [disabled]="skjema.invalid">
            {{ 'Opprett' | translate }}
        </button>
    </form>

    <div class="liste med-skillelinje std-max-innholdsbredde">
        <div class="liste-overskrift">{{ 'Aktive meldinger' | translate }}</div>
        @for (melding of aktiveMeldinger(); track melding.id) {
            <administrasjon-melding class="liste-rad" [melding]="melding" (slettet)="vedMeldingSlettet()" (opprettFraMal)="vedOpprettFraMal($event)"/>
        } @empty {
            <div>{{ 'ingen' | translate }}</div>
        }

        <div class="liste-overskrift">{{ 'Utløpte meldinger' | translate }}</div>
        @for (melding of utlopteMeldinger(); track melding.id) {
            <administrasjon-melding class="liste-rad" [melding]="melding" (slettet)="vedMeldingSlettet()" (opprettFraMal)="vedOpprettFraMal($event)"/>
        } @empty {
            <div>{{ 'ingen' | translate }}</div>
        }

        <div class="liste-overskrift">{{ 'Meldingsmaler' | translate }}</div>
        @for (melding of malMeldinger(); track melding.id) {
            <administrasjon-melding class="liste-rad" [melding]="melding" (slettet)="vedMeldingSlettet()" (opprettFraMal)="vedOpprettFraMal($event)"/>
        } @empty {
            <div>{{ 'ingen' | translate }}</div>
        }
    </div>
</administrasjon-navigasjon>
